<template lang="pug">
  .form-item.group__select
    span.form-item__title(v-if="title")
      | {{title}}
    .form-item__block(v-click-outside="close")
      span.form-item__error(v-if="error")
        | {{error}}

      .form-item__select.select(@click="toggleOpen")
        input.form-item__input(
          :disabled="true"
          :value='getData && getData.name ? ("Курс: "+ getData.name ): placeholder'
          :placeholder="placeholder"
        )

      SlideUpDown.select__slider(
        :duration="slideDuration"
        :active="isOpen"
      )
        .select__field
          Input(
            placeholder="Введите продукт"
            v-model="searchText"
            style="margin-bottom: 5px;"
          )
          label.folders-select__row.-folder-(
            style="flex-flow:row"
            @click="selectCourse()"
          )
            span.folders-select__text
              | Ничего не выбрать
          .folders-select__list(
            v-for="(item, itemIdx) in data" :key="item.folder.id"
          )
            label.folders-select__row.-folder-(
              style="flex-flow:row")
              span.folders-select__folder
                | Папка: {{item.folder.name}}

            label.folders-select__row.-course-(
              style="flex-flow:row"
              v-for="(course, courseIdx) in item.courseArray" :key="course.id"
              @click="selectCourse(course)"
            )
              span.folders-select__text
                | {{course.name}}


      Icon(
        v-if="value && value.name"
        class="form-item__delete"
        icon="input-delete"
        @click="clearInput"
      )

      Icon.select__icon.form-item__icon(
        v-else
        :icon="!icon ? 'arrow-down' : icon"
        @click="toggleOpen"
        :class="{'-opened-': isOpen}"
      )

</template>

<script>
import _ from 'lodash';
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Select',
  components: {
    SlideUpDown
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    title: {},
    placeholder: {},
    error: {},
    icon: {},
    value: {},
    selected: {}
  },
  data() {
    return {
      searchText: '',
      data: {},
      isOpen: false,
      slideDuration: 200,
      status: false,
      arrayId: []
    };
  },
  computed: {
    ...mapState('usersGroups', {
      folders: s => s.aside.data.folders
    }),
    getData() {
      let value;
      for (let i = 0; i < this.data.length; i++) {
        value = this.data[i].courseArray.find(el => el.id == this.value);
        if (typeof value !== 'undefined') {
          break;
        }
      }
      return value;
    }
  },
  watch: {
    folders() {
      this.setData();
    },
    searchText(val) {
      if (val) {
        this.data = _.cloneDeep(this.folders)
          .map(item => {
            const regex = new RegExp(this.searchText, 'gi');

            let obj = {};
            if (item.courseArray.some(c => regex.test(c.name))) {
              obj = {
                folder: item.folder,
                courseArray: item.courseArray.filter(c => {
                  const regex1 = new RegExp(this.searchText, 'gi');
                  return regex1.test(c.name);
                })
              };
            }

            return obj;
          })
          .filter(el => el.courseArray);
      } else {
        this.setData();
      }
    }
  },
  mounted() {
    this.getCourseSelect();
    this.setData();
  },
  methods: {
    ...mapActions('usersGroups', ['getCourseSelect']),
    setData() {
      this.data = _.cloneDeep(this.folders);
    },
    toggleChecked(itemIdx, idx) {
      const data = _.cloneDeep(this.data);
      const item = data[itemIdx];
      const arrayId = [];
      if (idx) {
        item.courseArray[idx].checked = !item.courseArray[idx].checked;
        item.folder.checked = false;
      } else {
        if (item.folder.checked) {
          item.folder.checked = false;
        } else {
          item.folder.checked = true;
          item.courseArray.forEach(el => {
            arrayId.push(el.id);
            el.checked = true;
          });
        }
      }

      this.data = { ...data };
    },
    selectCourse(course) {
      if (typeof course !== 'undefined') {
        this.$emit('input', course.id);
      } else {
        this.$emit('input', '');
      }

      this.close();
    },
    clearInput() {
      this.$emit('input', '');
      this.close();
    },
    toggleOpen() {
      if (this.folders.length > 0) {
        this.isOpen = !this.isOpen;
      }
    },
    close() {
      this.isOpen = false;
      this.searchText = '';
    }
  }
};
</script>
